import { mapActions, mapState } from 'vuex';
import { timeNow, today } from '@/utils/format';

export default {
  data() {
    return {
      ref_berkas: null,
      action: null,
      alert: true,
      isUpdate: false,
      tab: 0,
      cv: 0,
      formulir: {},
      autosaveCv: null,
    };
  },
  created() {
    this.getMasters(['propinsi', 'kota', 'kualifikasi'].join(';'));
    this.fetch({ id: this.profilID, reset: true });
    this.option(this.profilID);
  },
  computed: {
    ...mapState('preferensi', {
      instruktur: (state) => state.data?.instruktur ?? {},
      peserta: (state) => state.data?.peserta ?? {},
      config: (state) => state.data?.config ?? {},
      peserta_status: (state) => state.data?.peserta_status ?? {},
      instruktur_status: (state) => state.data?.instruktur_status ?? {},
      instruktur_cadangan: (state) => state.data?.instruktur_cadangan ?? {},
    }),

    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('cv', {
      profil: (state) => state?.detail ?? {},
      opsi: (state) => state?.opsi ?? {},
      meta: (state) => state?.meta ?? {},
    }),

    gelombang() {
      return this.$getDeepObj(this.config, `${this.isKasek ? 'peserta' : 'pelatih_ahli'}.gelombang`);
    },

    profilID() {
      const id = this.peserta?.psp_profil_id ?? this.instruktur?.psp_profil_id;
      return id;
    },

    wktTutup() {
      return this.$getDeepObj(
        this.config,
        `${this.isKasek ? 'peserta' : 'pelatih_ahli'}.registrasi.${this.gelombang || 1}.wkt_selesai`
      );
    },

    status() {
      return this.meta?.status_lengkap ?? {};
    },

    isLengkap() {
      return this.$getDeepObj(this.meta, 'is_lengkap');
    },

    isKasek() {
      return !!Object.keys(this.peserta).length;
    },

    kVerval() {
      const kVerval = this.isKasek ? this.peserta?.k_verval_psp : this.instruktur?.k_verval_psp;
      return kVerval;
    },

    prosesVerval() {
      const listProses = this[this.isKasek ? 'peserta' : 'instruktur']?.psp_profil_proseses ?? [];
      const prosesVerval = listProses.filter((item) => item.k_profil_proses_psp === 8)[0];
      return prosesVerval;
    },

    catatanVerval() {
      const alasan = JSON.parse(this.$getDeepObj(this.prosesVerval, 'catatan') || `[]`);
      return alasan.map((item) => (this.$isObject(item) ? item.value : item)).join('<br/>');
    },

    isAjuan() {
      const kVerval = this.isKasek ? this.peserta?.k_verval_psp : this.instruktur?.k_verval_psp;
      return kVerval > 1;
    },

    tutupPendaftaran() {
      return this.isKasek ? this.peserta_status.tutup || '' : this.instruktur_status.tutup || '';
    },

    isCadangan() {
      return this.isKasek ? Number(this.peserta && this.peserta.is_cadangan) >= 1 : false;
    },
  },
  methods: {
    ...mapActions('master', ['getMasters']),

    ...mapActions('cv', ['fetch', 'option', 'saveProfil', 'upload', 'uploadPakta']),

    onCloseModal() {
      clearInterval(this.autosaveCv);
      this.$refs.modal.dialog = false;
    },

    onEdit(payload) {
      if (this.tutupPendaftaran) {
        const msg = `<p class="title mb-2">Mohon maaf! ${this.tutupPendaftaran}`;
        this.$info(msg, `Perubahan data tidak diperbolehkan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      if (this.isAjuan && this.kVerval !== 5) {
        const msg = `<p class="title mb-2">Mohon maaf! Data Anda telah diajukan dan dalam Proses verval, 
                    sehingga tidak dapat diubah untuk saat ini</p> 
                    Jika Anda ingin mengubah Data Anda, silakan melakukan aksi batal ajuan`;
        this.$warning(msg, `Ubah Data`);
        return;
      }

      if (
        ['organisasi', 'organisasi_pa', 'komunitas', 'bimbingan'].includes(payload.type) &&
        this.getTemp(payload.type) !== null
      ) {
        const data = this.getTemp(payload.type);
        const message = [
          '<div class="black--text">',
          '<h3 class="subtitle-1">',
          `Sistem mendeteksi adanya <b class="warning--text">Data yang belum tersimpan</b> pada ${this.$localDate(
            data && data.date,
            false,
            true,
            false,
            true
          )}`,
          '</h3>',
          '<h3 class="subtitle-1 font-weight-bold" style="font-size: 15px">Apakah Anda ingin memakai Data tersebut?</h3>',
          '</div>',
        ].join('');

        this.$confirm(message, `Data Perolehan Kembali`, {
          tipe: 'error',
          lblConfirmButton: 'Pakai',
          lblCancelButton: 'Jangan Pakai',
          useReject: true,
        })
          .then(() => {
            this.editing(payload, true);
          })
          .catch(() => {
            this.editing(payload);
            this.clearTemp(payload.type);
          });
      } else {
        this.editing(payload);
      }
    },

    editing(payload, useTempData) {
      let parent = this.items.filter((item) => {
        if (!item.children) {
          return item.id === payload.type;
        } else {
          return (
            (item.children || []).filter((child) => {
              return child.id === payload.type;
            }).length > 0
          );
        }
      });
      parent = (parent && parent[0]) || {};
      let child = (parent.children || []).filter((item) => {
        return item.id === payload.type;
      });
      child = (child && child[0]) || {};

      const initValue = useTempData
        ? this.getTemp(payload.type) && this.getTemp(payload.type)['data']
        : this.getData(payload.type);

      const items = this.getDataTable(parent.table || child.table || payload.type);
      this.action = items.length ? 'update' : 'add';
      this.$set(this.formulir, 'type', payload.type || 'profil');
      this.$set(this.formulir, 'title', `Lengkapi CV`);
      this.$set(this.formulir, 'subtitle', this.$getDeepObj(this, `contents.${payload.type}.title`));
      this.$set(this.formulir, 'form', this.$getDeepObj(this, `contents.${payload.type || 'profil'}.form`));
      this.$set(this.formulir, 'max', Number(this.$getDeepObj(this, `contents.${payload.type}.max`)) || '');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'mode', 'insert');
      this.$set(this.formulir, 'action', this.action);
      this.$set(this.formulir, 'items', useTempData ? initValue : items);
      this.$set(this.formulir, 'deskripsi', parent.deskripsi || child.deskripsi || '');
      this.$set(this.formulir, 'guru', this.isGuru);
      this.$set(this.formulir, 'gelombang', this.$getDeepObj(this.profil, 'gelombang'));
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        if (['organisasi', 'organisasi_pa', 'komunitas', 'bimbingan'].includes(payload.type)) {
          clearInterval(this.autosaveCv);
          this.onSetAutoSave(payload.type);
          this.$set(this.formulir, 'init', initValue);
        } else if (['dasar', 'pa'].includes(payload.type)) {
          this.$set(
            this.formulir,
            'init',
            Object.assign({}, initValue, {
              is_update_nik: this.$getDeepObj(this.meta, 'is_update_nik') || false,
              is_update_alamat: this.$getDeepObj(this.meta, 'is_update_alamat') || false,
            })
          );
        } else {
          this.$set(this.formulir, 'init', this.getData(payload.type));
        }
      });
    },

    onUpload(payload) {
      if (this.tutupPendaftaran) {
        const msg = `<p class="title mb-2">Mohon maaf! ${this.tutupPendaftaran}`;
        this.$info(msg, `Perubahan data tidak diperbolehkan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      if (this.isAjuan && this.kVerval !== 5) {
        const msg = `<p class="title mb-2">Mohon maaf! Data Anda telah diajukan dan dalam Proses verval, 
                    sehingga tidak dapat diubah untuk saat ini</p> 
                    Jika Anda ingin mengubah Data Anda, silakan melakukan aksi batal ajuan`;
        this.$warning(msg, `Ubah Data`);
        return;
      }

      const rules = {
        ktp: { format: 'JPEG/JPG/PNG', required: true },
        rekomendasi: { format: 'PDF', required: true },
        pernyataan: { format: 'PDF', required: true },
      };

      const rekomendasi = (this.$getDeepObj(this.profil, 'psp_profil_berkases.data') || []).filter((item) => {
        return [22, 23, 24].indexOf(+item.k_profil_berkas_psp) > -1;
      });
      // const berkas = (this.$getDeepObj(this.gpmFungsi, 'gpm_guru_berkases') || []).filter((item) => {
      //   return item.m_berkas_guru_gpm && item.m_berkas_guru_gpm.singkat === payload.type
      // })

      this.id = this.id || null;
      this.action = 'upload';

      this.ref_berkas = null;
      if (payload.type === 'rekomendasi') {
        this.ref_berkas = this.$getDeepObj(rekomendasi, '0.m_berkas_guru_gpm.singkat') || null;
      }

      let dokumen = (this.dokumens || []).find((s) => s.id === payload.type) || {};

      this.$set(this.formulir, 'form', 'FormUnggah');
      this.$set(this.formulir, 'title', `Unggah Berkas ${this.$titleCase(dokumen.label)}`);
      this.$set(this.formulir, 'type', payload.type);
      this.$set(this.formulir, 'format', `harus bertipe ${this.$getDeepObj(rules, `${payload.type}.format`)}`);
      this.$set(this.formulir, 'rules', this.$getDeepObj(rules, `${payload.type}`));
      this.$set(this.formulir, 'mode', 'upload');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'max', 1500);
      this.$set(
        this.formulir,
        'detail',
        this.dokumens.find((s) => s.id === payload.type)
      );
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        // this.$set(this.formulir, 'init', berkas[0])
      });
    },

    onSetAutoSave(type) {
      this.autosaveCv = setInterval(() => {
        this.saveTemp(type);
      }, 3 * 10 * 1000);
    },

    saveTemp(type) {
      const data = (this.$refs.formulir && this.$refs.formulir.getValue()) || [];
      const date = [today(), timeNow()].join(' ');
      if (data.length) window.localStorage.setItem(type, JSON.stringify(Object.assign({}, { date, data })));
    },

    getTemp(type) {
      if (!type) return null;

      const data = window.localStorage.getItem(type);
      return JSON.parse(data);
    },

    clearTemp(type) {
      window.localStorage.removeItem(type);
    },

    onSave(type, param) {
      if (this.action === 'upload') {
        this.uploadData();
      } else {
        this.saveData(type, param);
        if (['organisasi', 'organisasi_pa', 'komunitas', 'bimbingan'].includes(type)) this.clearTemp(type);
      }
    },

    saveData(type, param) {
      const params = param || this.$refs.formulir.getValue() || {};
      let mapParams = this.mapParam(params, type);
      let msg = `${this.action === 'update' ? 'Perubahan ' : ''} Data ${this.contents[type] &&
        this.contents[type]['title']} berhasil ${
        this.action === 'delete' ? 'dihapus' : this.action === 'add' ? 'ditambahkan' : 'disimpan'
      }`;

      this.saveProfil({
        id: this.profilID,
        tipe: type === 'dasar' ? '' : type === 'organisasi_pa' ? 'organisasi-pa' : type,
        params: mapParams,
      })
        .then(() => {
          this.fetch({ id: this.profilID, reset: true });
          this.$success(msg);
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    uploadData() {
      const params = this.$refs.formulir.form || {};
      const formData = new FormData();
      const type = this.formulir.type;
      const isPa = Number(this.profil && this.profil.k_profil_psp) === 1 || false;
      let mapParams = this.appendData(
        Object.assign(
          {},
          !isPa && type === 'pakta'
            ? {
                file_pakta: params['file'],
              }
            : { label: type, file: params['file'] }
        ),
        false,
        formData
      );

      this[!isPa && type === 'pakta' ? 'uploadPakta' : 'upload']({
        id: this.profilID,
        tipe: type,
        params: mapParams,
      })
        .then(() => {
          this.$success(`Berkas berhasil diunggah`);
          this.fetch({ id: this.profilID, reset: true });
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    appendData(data, obj, FormData) {
      if (data && this.$isObject(data)) {
        for (let key in data) {
          let name = (obj && `${obj}[${key}]`) || key;
          if (data[key] && this.$isObject(data[key])) {
            this.appendData(data[key], name, FormData);
          } else {
            FormData.append(name, data[key]);
          }
        }
        return FormData;
      }
    },

    getDataTable(table) {
      const prefix = table === 'komunitas' ? 'es' : 's';
      return (
        this.$getDeepObj(
          this.profil,
          `psp_profil_${table ? (table === 'organisasi_pa' ? 'organisasi' : table || '') : ''}${prefix}.data`
        ) || []
      );
    },
  },
};
